module.exports = __webpack_public_path__ + "img/about.940e6f29.png";